import React, { memo } from 'react'
import {
  BWPanel,
  BWPanelHeader,
  BWText,
  CSS_GRID,
  CSS_JUSTIFY_CONTENT_CENTER,
  CSS_FULL_WIDTH,
  CSS_ALIGN_ITEMS_CENTER,
  openExternalUrl
} from 'src/libs/qb-brand-web-components'
import styled from '@emotion/styled'
import CountUpAnimation from 'react-countup'

import {
  OVERVIEW_PADDING_SMALL,
  OVERVIEW_PADDING_DEFAULT
} from '../../styles/shared'
import { getNonNegativeNumber } from '../../util/brand.helpers'
import brandConfig from 'brandConfig'
import OverviewEnterCode from './OverviewEnterCode'
import { exchangeProviderLabel } from '../../util/pointsExchange.helpers'
import Button from '../shared/button/Button'
import { formatTicks } from '../../util/string.helpers'
import OverviewHowToEarnWrapper from 'wrappers/OverviewHowToEarnWrapper'

const OverviewMainPanel = ({
  onEnterRewardCodeClick,
  currentUserPoints,
  previousUserPoints,
  tokenProfile: { name, symbol },
  t,
  onClickHowToEarn,
  icon,
  css,
  navItemsMoreLength,
  customCss
}) => {
  return (
    <BWPanel padding={15} css={{ maxHeight: '500px', ...css }}>
      <OverviewTitleContent
        navItemsMoreLength={navItemsMoreLength}
        customCss={customCss}
      >
        <BWPanelHeader
          title={
            <BWText
              label={
                <CountUpAnimation
                  start={previousUserPoints}
                  end={getNonNegativeNumber(currentUserPoints)}
                  duration={2}
                  formattingFn={formatTicks}
                />
              }
              size={50}
              weight={800}
            />
          }
          description={exchangeProviderLabel({ name, symbol })}
          icon={icon}
          color={brandConfig.prefIconColor}
        />
        <OverviewEnterCode
          t={t}
          onEnterRewardCodeClick={onEnterRewardCodeClick}
          howToEarnLink={
            !brandConfig.features.disableHowToEarnRewards && (
              <OverviewHowToEarnWrapper t={t} onClick={onClickHowToEarn} />
            )
          }
          howDoesItWorkButton={
            brandConfig.redirectUrl && (
              <Button
                label={t('brand:reward.how-to-earn-rewards')}
                onClick={() => openExternalUrl(brandConfig.redirectUrl)}
              />
            )
          }
        />
      </OverviewTitleContent>
    </BWPanel>
  )
}

export default memo(OverviewMainPanel)

const OverviewTitleContent = styled.div`
  ${CSS_GRID};
  ${CSS_JUSTIFY_CONTENT_CENTER};
  ${CSS_FULL_WIDTH};
  ${CSS_ALIGN_ITEMS_CENTER};
  ${({ navItemsMoreLength }) =>
    navItemsMoreLength ? OVERVIEW_PADDING_SMALL : OVERVIEW_PADDING_DEFAULT};
  ${({ customCss }) => customCss};
`
